<template>
    <div class="modal fade" id="tour_pay_modal" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 750px;">
            <div class="modal-content">
                <div class="modal-header" style="">岸上观光服务</div>
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <ul class="list-null" v-if="freeShorex.length == 0 && payShorex.length == 0">
                        <li>
                            <img style="margin-top: 50px;" class="null" src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorex.png">
                            <div class="text">
                              <img src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorexTextIcon.png" alt="">
                              <div v-html="payShorexOnlyStr"></div>
                            </div>
                        </li> 
                    </ul>
                    <div class="content">
                        <!--导航-->
                        <ul class="modal-nav">
                            <li v-if="payShorex.length > 0"
                                :class="{ active: activeTab == 'payShorex'}"
                                @click="activeTab = 'payShorex'">
                                皇家精品游（付费）
                            </li>
                            <li v-if="freeShorex.length > 0"
                                :class="{ active: activeTab == 'freeShorex'}"
                                @click="activeTab = 'freeShorex'"
                            >
                                皇家常规游（免费）
                            </li>
                        </ul>
                        <!--皇家精品游-->

                        <ul class="list" v-show="activeTab == 'payShorex'">
                            <li v-for="(shorex, i) in payShorex" :key="('payShorex_' + i)">
                                <div class="img-tour">
                                  <div class="banner-swiper">
                                    <shore-sightsee-swiper :banner-list="shorex.bannerList"></shore-sightsee-swiper>
                                  </div>

                                    <div class="detail">
                                        <div class="title">
                                            <span class="line"></span>
                                            <span class="text">{{shorex.shorexName}}</span>
                                        </div>
                                        <div class="blod-title">
                                            {{shorex.shorexBrief}}
                                        </div>
                                        <div class="intro" v-if="shorex.duration && shorex.duration.length > 0">
                                            <img src="https://resource.rcclchina.com.cn/cruiseDetail/time.png" alt="Alternate Text">
                                            <span>时长: {{shorex.duration}}</span>
                                        </div>
                                        <div class="intro" v-if="shorex.shorexPrice && shorex.shorexPrice > 0">
                                            <img src="https://resource.rcclchina.com.cn/cruiseDetail/price.png" alt="Alternate Text">
                                            <span>价格: {{shorex.shorexPrice}}美元/人</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="desc" v-html="shorex.shorexDescription">

                                </div>
                            </li>
                        </ul>
                        <!--皇家常规游-->
                        <ul class="list" v-show="activeTab == 'freeShorex'">
                            <li v-for="(shorex, i) in freeShorex" :key="('freeShorex' + i)">
                                <div>
                                    <div class="main-title" style="">
                                        <span class="line"></span>
                                        <span class="scene">{{shorex.shorexName}} - {{shorex.duration}}</span>
                                    </div>
                                    <div class="item free-shorex-content" v-html="shorex.shorexDescription">
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!--底部-->
                        <div class="foot" v-if="freeShorex.length > 0 || payShorex.length > 0">
                            <div class="notice">注:</div>
                            <div class="parah">
                                <span class="parah-num">1)</span>船票支付成功后，您可选订皇家精品游（付费）；均数量有限，先到先得。如不选订任何行程则视为自助游，您需自行安排目的地游览行程。
                                    <!-- <span v-if="fressShorex&&freeShorex.length>0">预订船票时，将为您自动选中皇家常规游行程（免费）；船票支付成功后，可选择升级精品游服务。</span>
                                    <span v-else>本航次目前暂无皇家赠送岸上观光常规游，建议您提前安排靠港日活动，或在船票支付成功后，选择升级精品游服务。</span> -->

                            </div>
                            <div class="parah"><span class="parah-num">2)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</div>
                            <div class="parah"><span class="parah-num">3)</span>目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</div>
                            <div class="parah"><span class="parah-num">4)</span>皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/css/swiper.css'
import ShoreSightseeSwiper from "@/components/shoreSightseeSwiper.vue";
export default {
    name: "CruiseDetailShorexPopup",
    components: {
      ShoreSightseeSwiper,
    },
    props: {
        isShow: {
            type: Boolean
        },
        shorexInfo: {
            type: Object,
            default () {
                return {
                    freeShorex: [],
                    payShorex: [],
                    payShorexOnly: false
                }
            }
        }
    },
    data () {
        return {
            isShowModal: false,
            activeTab: '',
            swiperOptions: {
              loop: false,
              speed: 500,
              autoplay: false,
            },
          payShorexOnlyStr: null
        }
    },
    methods: {

        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
    },
    computed: {
        freeShorex () {
            if (!this.shorexInfo || !this.shorexInfo.freeShorex) return []
            return this.shorexInfo.freeShorex
        },
        payShorex () {
            if (!this.shorexInfo || !this.shorexInfo.payShorex) return []
            return this.shorexInfo.payShorex
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        },
        shorexInfo (newShorexInfo) {
            if (newShorexInfo.payShorex && newShorexInfo.payShorex.length > 0) {
                this.activeTab = 'payShorex'
            } else if (newShorexInfo.freeShorex && newShorexInfo.freeShorex.length > 0) {
                this.activeTab = 'freeShorex'
            } else {
                this.activeTab = ''
            }
            // 岸上观光文案
            if (newShorexInfo.payShorexOnly) {
              this.payShorexOnlyStr = "该航次岸上观光精品游行程（付费）尚未开放选订，选订开放后，我们<br>会在第一时间通知您，您也可以密切关注皇家加勒比官方网站。";
            } else {
              this.payShorexOnlyStr = "该航次岸上观光服务尚未开放选订，选订开放后，我们会在第一时间通<br>知您，您也可以密切关注皇家加勒比官方网站。";
            }
        }
    }
}
</script>

<style lang="less" scoped>

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
#tour_pay_modal {
    overflow-x: hidden;
    overflow-y: auto;
    .modal-header {
        border: 0;
        margin-left: 30px;
        font-size: 22px;
        color: #282b2c;
        font-weight: bold;
        padding: 0;
        padding-top: 30px;
    }
    .modal-body {
        padding: 20px 30px;
        line-height: 1.6;
        .list-null {
            li {
                width: 100%;
                height: 367px;
                img.null {
                    transform: translateX(-50%);
                    position: relative;
                    left: 50%;
                    //margin-bottom: 30px;
                    margin-top: 145px;
                }
                .text {
                    text-align: center;
                    //padding: 0 34px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #535252;
                    gap: 5px;
                    font-size: 18px;
                    position: relative;
                    //padding-left: 30px;
                  img{
                    display: block;
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    top: 5px;
                    left: 35px;
                  }
                }
            }
        }
        .modal-nav {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            margin-bottom: 24px;
            position: relative;
            li {
                margin-right: 6px;
                width: 180px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                color: #666;
                background: #f3f6f8;
                font-size: 14px;
                position: relative;
                cursor: pointer;
            }
            li.active {
                background: #54a3de;
                color: #fff;
            }
            li.active::after {
                content: '';
                display: block;
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -8px;
                border-style: solid;
                border-width: 8px;
                border-color: #54a3de transparent transparent transparent;
            }
        }
        .list {
            li {
                padding-bottom: 15px;
                border-bottom: 1px solid #d3dadd;
                padding-top: 26px;
                .img-tour {
                    display: flex;
                    .shorex-banner {
                        width: 290px;
                        height: 185px;
                        display: inline-block;
                        vertical-align: top;
                      img{
                        width: 100%;
                        height: 100%;
                      }
                    }
                    .detail {
                        width: 350px;
                        margin-left: 22px;
                        margin-bottom: 2px;
                        display: inline-block;
                        vertical-align: top;
                        .title {
                            margin-bottom: 16px;

                            .text {
                                font-size: 16px;
                                font-weight: bold;
                                color: #282b2c;
                            }
                        }
                        .blod-title {
                            font-size: 14px;
                            font-weight: bold;
                            color: #282b2c;
                            margin-bottom: 12px;
                            font-weight: 400;
                        }
                        .intro {
                            margin-bottom: 8px;
                            span {
                                margin-left: 3px;
                                color: #006ab9;
                            }
                        }
                    }
                  .banner-swiper{
                    width: 290px;
                    display: inline-block;
                    vertical-align: top;
                    img{
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
                .desc {
                    font-size: 14px;
                    line-height: 22px;
                    color: #333;
                    font-weight: 500;
                    margin-top: 13px;
                }
                .line {
                    width: 4px;
                    height: 14px;
                    background: #54A3DE;
                    display: inline-block;
                    margin-right: 2px;
                    position: relative;
                    top: 2px;
                }
                .main-title {
                    margin-bottom: 14px;
                    .scene {
                        font-size: 16px;
                        font-weight: bold;
                        color: #282b2c;
                    }
                    .item {
                        color: #282b2c;
                        font-size: 14px !important;
                        font-weight: bold;
                    }
                }
            }
            li:first-child {
                padding-top: 0;
            }
        }
        .foot {
            color: #747d80;
            font-size: 14px;
            line-height: 22px;
            padding-top: 12px;
            font-weight: 400;
        }
    }
}
.parah-num {
    display: inline-block;
    width: 20px;
}
</style>

<style lang="less">
#tour_pay_modal .free-shorex-content, #tour_pay_modal .free-shorex-content p, #tour_pay_modal .free-shorex-content span {
    font-size: 14px !important;
}
#tour_pay_modal .free-shorex-content p {
    margin-bottom: 0px;
    color: #282b2c;
    font-weight: bold;
}
</style>
